export enum WoonvisieEnum {
  CORPORATIE = 'Corporatie',
  CORPORATIE_EN_PARTICULIER = 'Corporatie en particulier',
  PARTICULIER = 'Particulier',
}
